export const ukSite = () => {
  console.log(process.env.GATSBY_WORDPRESS_URL)
  return process.env.GATSBY_WORDPRESS_URL.includes('app-uk.techsonthemove.com')
}
